<template>
  <div id="menu">
      <div class="container">
          <div class="menu-container">
              <div class="menu-title">
                  集团介绍
              </div>
              <div class="menu-link">
                  <div class="one" :class="{active:path=='home'}">
                      <a href="/#/home">公司介绍</a>
                  </div>
                  <div class="one" :class="{active:path=='culture'}">
                      <a href="/#/culture">企业文化</a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default { 
    data() {
        return {
            path:"home"
        }
    },
    mounted(){
        this.menuactive();
    },
    methods:{
        goCulture(){
            this.$router.push({name: '/#/culture'});
        },
        menuactive(){
            if(this.$route.path == "/culture"){
                this.path = 'culture';
            }else{
               this.path = 'home'; 
            }
        }

    }
}
</script>

<style scoped>
#menu{
    display:flex;
    justify-content: center;
    width:100%;
    height:80px;
    border-bottom:2px solid #f3f3f3;
}

#menu .container{
    width:1200px;
}

#menu .menu-container{
    display:flex;
    justify-content: space-between;
    align-items:center;
    width:100%;
    height:100%;
}

#menu .menu-title{

color: #000000;
font-size: 18px;
}

#menu .menu-link{
    display:flex;
    justify-content: space-between;
    align-items:center;
}

#menu .menu-link .one {
    position:relative;
    align-items: center;
}

#menu .menu-link .one a{

font-size: 18px;
color:#333;
margin-right: 40px;
}

#menu .menu-link .active::after{
    content:"";
    position:absolute;
    width:43px;
    height:3px;
    left:15px;
    top:49px;
    background-color: #D91414;
}
</style>


// WEBPACK FOOTER //
// src/components/sub/Menu.vue